import React, { Component } from 'react';
import { Button } from 'semantic-ui-react'
import { withTranslation } from "react-i18next";

class OwnBookingButtonNoTranslation extends Component {
  static propTypes = {

  };
  // TO provide Url to navigate back after reservation secure=true y from={{urlActual}} 
  render() {
    const { t } = this.props;
    return (
      <div className="common-own-booking-button">
        <a className="btn btn-success" href="https://beta.suiteclerk.com/reservas/61c9e00eeeb76402767c8a1c"><Button size='tiny' primary fluid>{t('general.bookingButtonText', { framework: 'React' })} </Button></a>
      </div>
    );
  }
}

const OwnBookingButton = withTranslation('common')(OwnBookingButtonNoTranslation)

export default OwnBookingButton;



// WEBPACK FOOTER //
// ./src/features/common/OwnBookingButton.js